import React from 'react';

import { Section } from '../..';
import { defaultPropTypes } from '../AdditionalData';
import { checkSectionCondition } from '../../../Form.helpers';

const DriverLicense = ({ field, translations }) => {
    const getVal = () => {
        switch (field.value) {
            case true:
                return translations.has;
            case false:
                return translations.hasNot;
            default: return null;
        }
    };
    const renderedSection = checkSectionCondition(getVal());

    return (
        <Section.Conditional
            condition={Boolean(field.order) && renderedSection}
            title={translations.driverLicense}
        >
            {({ renderField }) => (
                renderField(translations.driverLicenseLabel, getVal())
            )}
        </Section.Conditional>
    );
};

DriverLicense.propTypes = defaultPropTypes;

export default DriverLicense;
